/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import signaturePopUp from "../signaturePopUp/signaturePopUp.vue"
import consentform from "../../custom_lib/dynamic_forms/consentformlib/consentform.vue"
import consentformtemplate from "../../custom_lib/dynamic_forms/consentformlib/consentformtemplate.vue"
import VuePdfEmbed from "vue-pdf-embed";
export default {
  name: "consentFormList",
  components: {
    consentform,
    consentformtemplate,
    VPagination,
    signaturePopUp,
    VuePdfEmbed
  },
  props: {
    patientLoginId: {
      type: String,
      default: ""
    },
    templateId: {
      type: String,
      default: ""
    },
    consentFormId: {
      type: String,
      default: ""
    },
    documentId: {
      type: String,
      default: ""
    },
    formId: {
      type: String,
      default: ""
    }

  },
  data() {
    return {
      // tokenId:"b6945994-b8e8-479d-b5d4-fa0ff2ab2d6a",
      // showVideoCall: false,
      currentselectedformname:"",
         templateId: this.$route.query.templateId || "",
    consentFormId: this.$route.query.consentFormId || "",
    documentId: this.$route.query.documentId || "",
    formId: this.$route.query.formId || "",
      esignvisitId:"",
      isFormLoading: false,
      esignsiteId:"",
      esignsubjectId:"",
      esignstudyId:"", 
      Initials:"",
        status:"",
        version :"",
        email:"",
        password:"",
        isConsent:false,
        disableInput: false,
      signdate:"",
      signinitials:"",
      consentdata:"",
      signedBy:"",
      errors: [],
       templateData: null,
      patientLogin: {},
      patientItem: {},
      documentlist: [],
      isDocumentLoading: false,
      isIcfExpanded: false,
      selectedIcfDocument: null,
      selectedIcfDocumentSource: "",
      selectedIcfDocumentObjectUrl: "",
      isIcfDocumentLoading: false,
      icfDocumentError: "",
      addScrollClass:false,
      SortProperty: "CreatedAt",
      pageindex: 1,
      pagesize: 10,
      SortOrder: 1,
      validations: [false, false],
      currentIndex:0,
      consentformvisible: false,
      concentdata:[],
      formFound:false,
      signpopUp:false,
      signatuestatus:"",
      signatureformId:"",
      modalStatus:"",
      signdate:"",
      signtime:"",
      signedby:"",
      signStatus:"",
      loggedinUser:"",
      TrueORfalse: false,
      shoeaddeditbtn:false,
      sheduleId: "",
      visitselected: false,
      showPopup: false,
      currentformid: "",
      isedittrue: false,
      milestone: "",
      isConsentSigned: false,
      selectedpageno: 1,
      pages: {},
      addformvar: false,
      remoteEmail: "",
      inviteButtonstats: true,
      showBlockpopup:false,
      visitidvar: "",
      //templateId: "",
      templatelist: {},
      expandfunvat: {},
      showBlock: [false],
      roleprivileges: "",
      selectedvisitid: "",
      selectedmodeltemplate: "",
      baseapi: process.env.VUE_APP_Service_URL,
      studyid: "",
      currentPageSize: 0,
      currentPageNumber: 0,
      visitList: [],
      totalItems: 0,
      totalCount: 0,
      totalPages: 0,
      searchData: {
        pagesize: 10,
        pageindex: 0,
        visitNo: "",
        FormName: "",
        SortProperty: "",
        SortOrder: 0,
      },
      requestData: {
        pagesize: 10,
        pageindex: 0,
        visitNo: "",
        FormName: "",
        SortProperty: "",
        SortOrder: 0,
      },
      pageNumbers: [],
      visitides: [],
      showDiv: false,
      mountedValue: false,
    };
  },
  async beforeMount(){
    store.dispatch("setShowonlyheadder", false);
    store.dispatch("setsourceUrl", true);
  },
async mounted() {
  store.dispatch("setNavbar", false);
  store.dispatch("setPatientNavbar", true);
  document.querySelector("#page-wrapper").style.width = "100%";
  
  // Get values from props or route params/query
  const patientId = this.patientLoginId || this.$route.params.patientLoginId;
  const templateIdValue = this.templateId || this.$route.query.templateId || this.$route.params.templateId;
  const consentFormIdValue = this.consentFormId || this.$route.query.consentFormId || this.$route.params.consentFormId;
  const formIdValue = this.formId || this.$route.query.formId || this.$route.params.formId;
  console.log("Mounted - patientLoginId:", patientId);
  console.log("Mounted - templateId:", templateIdValue);
  console.log("Mounted - consentFormId:", consentFormIdValue);
  console.log("Route params:", this.$route.params);
  console.log("Route query:", this.$route.query);
  
  // Set templateId and consentFormId if they came from route
  if (templateIdValue && !this.templateId) {
    this.templateId = templateIdValue;
  }
  if (consentFormIdValue && !this.consentFormId) {
    this.consentFormId = consentFormIdValue;
  }
  
  const idtoken = store.getters.getIdToken;
  
  window.addEventListener("FormDigitalSignature", (event) => {
    if (event.detail.storage == true) {
      this.getSignStatus();
    }
  });
  
  window.addEventListener("studyIdChanged", async (event) => {
    const getsourceUrl = store.getters.getsourceUrl;
    const boolgetsourceUrl = store.getters.getsourceUrl;
    await this.setstudy();
    this.currentPageSize = 10;
    this.currentPageNumber = 1;
    this.requestData.pagesize = 10;
    this.requestData.pageindex = 1;
    if (boolgetsourceUrl == true || getsourceUrl == 'true') {
      await this.ScheduleData();
    } else {
      await this.getdata();
    }
  });
  
  const getsourceUrl = await store.getters.getsourceUrl;
  const boolgetsourceUrl = await store.getters.getsourceUrl;
  
  await this.setroleprivileges();
  await this.setstudy();
  await this.getPatientloginInfo();
  
  this.currentPageSize = 10;
  this.currentPageNumber = 1;
  this.requestData.pagesize = 10;
  this.requestData.pageindex = 1;
  this.mountedValue = true;
  
  if (boolgetsourceUrl == true || getsourceUrl == 'true') {
    await this.ScheduleData();
  }
  
  await this.getconcentdata();
  this.setSignatureContext();
  if (!this.currentformid) {
    this.currentformid = this.formId || this.consentFormId || localStorage.getItem("consentformid") || this.currentformid;
    if (this.currentformid) {
      localStorage.setItem("consentformid", this.currentformid);
    }
  }
  await this.showicfform();
  await this.showconsentform(false);
  await this.updateconsentbysubject("SUBJECT_VIEWED");
  await this.updateconsnetformviewed();
 
},
  unmounted() {
    store.dispatch("setsourceUrl", false);
    store.dispatch("setShowonlyheadder", true);
  },
  methods: {
    parentFunction(){
      //empty Function
    },
    getPatientLoginId() {
      return this.patientLoginId || this.$route.params.patientLoginId || this.$route.query.patientLoginId || "";
    },
    async getPatientloginInfo() {
      const patientLoginId = this.getPatientLoginId();
      if (!patientLoginId) {
        return;
      }

      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseapi}/account-core/user/getencryptedpatientinfo?patientLoginId=${patientLoginId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.patientLogin = res.data || {};
        })
        .catch((err) => {
          console.log(" error get patient login", err);
          this.patientLogin = {};
        });
    },
    async validateIsNull() {
      this.email = this.email.replace(/ +/g, ' ').trim();
      this.password = this.password.replace(/ +/g, ' ').trim();
      if (this.email != "") {
        this.validations[0] = true;
      }
      else{
        this.validations[0] = false;
      }
      if (this.password != "") {
        this.validations[1] = true;
      }
      else{
        this.validations[1] = false;
      }
    

    },
    async saveSignData() {
      await this.validateIsNull();
      if (this.validations.includes(false)) {
        this.errors = this.validations;
      }
      else {
        if(this.isConsent==true){
          this.status="Consented";
          await this.saveSignapicall();
        }
        else{
        this.status="Dissented";
        if (confirm("We have noticed that you have not selected to accept the consent. \nAre you sure you want to continue?")) {
          await this.saveSignapicall();
        }
        else{

        }
        }
    
      }
    },
    //   async saveSignapicall(){
    //   if(this.Initials !=null){
    //     this.Initials = this.Initials.toUpperCase();
    //   }
    //   const patientLoginId = this.getPatientLoginId();
    //   const idtoken = store.getters.getIdToken;
    //   await axios
    //     .put(`${this.baseapi}/account-core/user/signconsent?patientLoginId=${patientLoginId}&status=${this.status}&email=${this.email}&password=${this.password}`,{},
    //     {
    //       headers: {
    //         Authorization: "Bearer " + idtoken,
    //         "Content-Type": "application/json",
    //       },
    //     })

    //     .then((res) => {
    //      this.updatePatientEConsent();
    //      this.$router.push(`/acknowledgement`)
        
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       var result = err.response.data.errors.DomainValidations[0];
    //       alert(result);
    //     });
    // },`${this.baseapi}/account-core/user/signconsentform?patientLoginId=${patientLoginId}&formId=${this.currentformid}&status=${this.status}&email=${this.email}&password=${this.password}`,{},
         async saveSignapicall(){
      if(this.Initials !=null){
        this.Initials = this.Initials.toUpperCase();
      }
      const patientLoginId = this.getPatientLoginId();
      const idtoken = store.getters.getIdToken;
      await axios
        .put(
            `${this.baseapi}/account-core/user/signconsentform?loginId=${patientLoginId}&status=${this.status}&email=${this.email}&password=${this.password}&consentRecordId=${this.currentformid}`,{},
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })

        .then((res) => {
          // this.updateconsentbysubject("SUBJECT_VIEWED");
        // this.updatePatientEConsent();
         this.updateconsentbysubject("SUBJECT_SIGNED");
         this.$router.push(`/acknowledgement`);
        
        })
        .catch((err) => {
          console.log(err);
          var result = err.response.data.errors.DomainValidations[0];
          alert(result);
        });
    },
    // async saveSignapicall(){
    //   if(this.Initials !=null){
    //     this.Initials = this.Initials.toUpperCase();
    //   }
    //   const patientLoginId = this.getPatientLoginId();
    //   const idtoken = store.getters.getIdToken;
    //   await axios
    //     .put(`${this.baseapi}/account-core/user/signconsent?patientLoginId=${patientLoginId}&Initials=${this.Initials}&status=${this.status}&email=${this.email}&password=${this.password}`,{},
    //     {
    //       headers: {
    //         Authorization: "Bearer " + idtoken,
    //         "Content-Type": "application/json",
    //       },
    //     })

    //     .then((res) => {
    //      this.updatePatientEConsent();
    //      this.$router.push(`/acknowledgement`)
        
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       var result = err.response.data.errors.DomainValidations[0];
    //       alert(result);
    //     });
    // },
   async updatePatientEConsent() {
    const consentform = localStorage.getItem('consentformid')||"";
  const idtoken = store.getters.getIdToken;
console.log("Updating patient e-consent with the following details:",this.templateId);
  const payload = {
    patientId: this.getPatientLoginId(),        
    studyId: this.esignstudyId,            
    formId: consentform,   
    milestone: "",
    isConsentSigned: true,   
    consentSignedDate: new Date().toISOString(),
  };

  console.log("updatePatientEConsent payload:", payload); 

  await axios
    .put(
      `${this.baseapi}/management/patient/updatepatienteconsent`,
      payload,
      {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
    )
       .then(() => {
      window.dispatchEvent(new CustomEvent("eConsentUpdated"));
    })
    .catch((err) => {
      console.log(err);
      var result = err.response.data.errors.DomainValidations[0];
      alert(result);
    });
},
    async showconsentform(clearDocument = true){
    await this.isSigned();
    this.consentformvisible = true;
    if (clearDocument) {
      this.isIcfExpanded = false;
      this.clearIcfDocument();
      this.currentselectedformname = "e-Signature";
    }
    },
    async showConsentForms() {
      this.consentformvisible = false;
      this.isIcfExpanded = false;
      this.clearIcfDocument();

      if (this.concentdata.length === 0) {
        await this.getconcentdata();
      }

      const selectedConsentForm =
        this.concentdata[this.currentIndex] || this.concentdata[0];

      if (selectedConsentForm) {
        const selectedIndex = this.concentdata.indexOf(selectedConsentForm);
        await this.expandfun(selectedConsentForm, selectedIndex, true, false);
        return;
      }

      this.currentselectedformname = "Consent Forms";
      await this.getdata();
    },
    async showicfform(){
      this.isIcfExpanded = true;
      this.currentselectedformname = "ICF Form";
      this.consentformvisible = true;

      if (this.documentlist.length === 0) {
        await this.getDocuments();
      }

if (this.documentlist.length > 0 && !this.selectedIcfDocumentSource) {
  const document = this.documentlist[0];
  await this.viewDocument(
    document.icf.icfDocumentId,          // ✅ use formId from icf
    document.icf.version,   // ✅ use versionNumber from icf
    document
  );
}


    },
    setSignatureContext() {
      const consentForm = this.concentdata[this.currentIndex] || this.concentdata[0] || {};
      const storedConsentId = localStorage.getItem("consentformid") || "";

      this.esignvisitId = consentForm.visitId || "";
      this.esignsiteId = consentForm.siteId || "";
      this.esignsubjectId = consentForm.subjectId || "";
      this.esignstudyId = consentForm.studyId || this.studyid || "";
      this.templateId = consentForm.tempId || this.templateId;
      this.currentformid = consentForm.formId || consentForm.formid || consentForm.consentFormId || this.consentFormId || this.formId || storedConsentId || this.currentformid;
      this.sheduleId = consentForm.sheduleId || "";

      if (this.currentformid) {
        localStorage.setItem("consentformid", this.currentformid);
      }
    },
    clearIcfDocument() {
      if (this.selectedIcfDocumentObjectUrl) {
        URL.revokeObjectURL(this.selectedIcfDocumentObjectUrl);
      }
      this.selectedIcfDocument = null;
      this.selectedIcfDocumentSource = "";
      this.selectedIcfDocumentObjectUrl = "";
      this.isIcfDocumentLoading = false;
      this.icfDocumentError = "";
    },
    async fetchDocumentSource(url) {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + idtoken,
          },
          responseType: "blob",
        });
        // Check if the response is a PDF
        const contentType = response.headers['content-type'] || response.headers['Content-Type'];
        console.log("Document content type:", contentType);
       if (contentType && (contentType.includes('application/pdf') || contentType.includes('application/octet-stream'))) {
          return URL.createObjectURL(response.data);
        } else {
          console.warn("Received non-PDF content type:", contentType);
          return "";
        }
      } catch (error) {
        console.error("Error fetching document source:", error);
        return "";
      }
    },
    async isSigned(){
      const idtoken = store.getters.getIdToken;
      const patientLoginId = this.getPatientLoginId();
      if (!patientLoginId) {
        return;
      }
      await axios.get(
        `${this.baseapi}/account-core/user/getsigneddetails?patientLoginId=${patientLoginId}`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          }
        })
        .then((res) => {
         if(res.data.status!=null){
          this.signinitials=res.data.initials;
          this.consentdata =  res.data.status=="Consented"? "Consented" :"Dissented";
          this.isConsent = res.data.status=="Consented"? true :false;
          this.signedBy = res.data.signedBy;
          this.signdate = res.data.signedDate;
          this.disableInput= true;
          
         }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async signatureClick(status) {
      this.signpopUp = true;
      this.signatuestatus = status
      this.signatureformId = this.currentformid
      if (status == "Signed") {
        this.modalStatus = "Sign"
      }
      else if (status == "Unsigned") {
        this.modalStatus = "Unsign"
      }
    },
    filter(date) {
      const formattedDate = moment(date).format('DD-MM-YYYY hh:mma')
      return date = formattedDate;
    
    },
    async getSignStatus() {
      if (!this.currentformid) {
        console.warn("Skipping getSignStatus because currentformid is empty");
        return;
      }
      console.log("form sign status from viewcomponent page", this.currentformid);
      const idtoken = store.getters.getIdToken;
      await axios.get(
        `${this.baseapi}/forms/forms/signstatus?formId=${this.currentformid}`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          }
        })
        .then((res) => {
          console.log("Form sign is", res);
          this.signdate = res.data.signedAt;
          this.signtime = moment(this.signdate).format("hh:mm a")
          this.signedby = res.data.signedUserName
          this.signStatus = res.data.signStatus
          this.loggedinUser = res.data.loggedInUser
          console.log("Form sign status is", this.signStatus);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async openInfo() {
      document.body.style.overflowY = "hidden"
      this.showPopup = !this.showPopup;
    },

    // async openInfo() {
    //   this.showVideoCall = true;
    // },

    async closemodal() {
      document.body.style.overflowY = "auto"
      this.showPopup = false;
    },
    OnUserTypeOnEmailField() {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.remoteEmail)) {
        this.inviteButtonstats = false;
      } else {
        this.inviteButtonstats = true;
      }
    },
    async OnUserClickedInvite() {
      const idtoken = store.getters.getIdToken;
      const dateTimeNow = new Date().toISOString();
      await axios
        .post(`${this.baseapi}/management/videocall/roomlink?dateTime=${dateTimeNow}`,
          [
            this.remoteEmail
          ],
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          alert("Invited successfully.")
          console.log(res.data);
          this.closemodal()
          this.remoteEmail = null;
          this.inviteButtonstats = true;
        })
        .catch((err) => {
          alert("Something went wrong.")
          console.log(err);
        });
    },

    async ScheduleData() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/management/patientschedule/getshedules?StudyId=${this.studyid}&PageNo=1&ItemCount=10&sortprop=&isDes=true&PatientID=${this.patientLoginId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.totalCount < 1) {
            this.searchAndGetData();
          }
          else {
            this.visitList = res.data.data;
            this.totalItems = res.data.visitCont;
            this.totalCount = res.data.totalCount;
            console.log("total count is", this.totalCount);
            this.totalPages = parseInt(this.totalCount / pSize);
            if (this.totalCount % pSize != 0) {
              this.totalPages = this.totalPages + 1;
            }
            this.totalItems = res.data.userCont;
          }
        }
        )
        .catch((err) => {
          console.log(err);
        });
    },
    async getconcentdata() {
      const idtoken = store.getters.getIdToken;
      const patientLoginId = this.getPatientLoginId();
      await axios
        .get(
          `${this.baseapi}/forms/template/templatedetails?iseConsent=true&patientLoginId=${patientLoginId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.concentdata = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async searchAndGetData() {
      this.studyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/management/visit/listvisit?StudyId=${this.studyid}&IsEConsent=true`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log("respp", res.data.results);

          this.visitList = res.data.results;
          if (this.visitList.length == 0) {
            this.showDiv = true
          }
          else {
            this.showDiv = false
          }
          this.totalItems = res.data.visitCont;
          this.totalCount = res.data.totalCount;
          console.log("total count is", this.totalCount);
          this.totalPages = parseInt(this.totalCount / pSize);
          if (this.totalCount % pSize != 0) {
            this.totalPages = this.totalPages + 1;
          }

          this.totalItems = res.data.userCont;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    createVisit() {
      this.$router.push(`/addvisit/0`)
    },
    SortSelected(sortProp, id) {
      console.log('SortPropChanged', sortProp);
      console.log(this.requestData.SortOrder)
      const selectedElement = document.getElementById(id)
      const selectedElementID = document.getElementById(id).id
      if (sortProp != null && id == selectedElementID) {
        if (this.requestData.SortOrder == 0) {
          // if(selectedElement.classList.contains("sortDesc")){
          //   return
          // }
          if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc")
            selectedElement.classList.add("sortDesc")
          }
          else selectedElement.classList.add("sortDesc")
        }
        else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc")
            selectedElement.classList.add("sortAsc")
          }
          // else if(selectedElement.classList.contains("sortAsc"))
          // {
          //   return
          // }          
          else selectedElement.classList.add("sortAsc")
        }
      }
      this.requestData.pageindex = 1;
      this.currentPageNumber = 1;
      this.requestData.SortProperty = sortProp;
      this.requestData.SortOrder = this.requestData.SortOrder == 0 ? 1 : 0;
      this.searchAndGetData();
    },
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
    },
    async assignFun() {
      if (this.selectedmodeltemplate == "") {
        alert(this.$t('navigations.please select a template'))
      }
      else {
        const idtoken = store.getters.getIdToken;
        await axios
          .put(`${this.baseapi}/management/visit/assigntemplate`,
            {
              "createdUserEmail": "",
              "createdUserId": "",
              "createdAt": new Date(),
              "lastModifiedUserEmail": "",
              "lastModifiedUserId": "",
              "lastModifiedAt": new Date(),
              "visitID": this.selectedvisitid,
              "templateID": this.selectedmodeltemplate,
              "version": "1.0"
            },
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            alert(this.$t('navigations.template assigned successfully'));
            this.selectedmodeltemplate = ""
            console.log(res.data);
          })
          .catch((err) => {
            console.log("error");
            console.log(err);
          });
        this.closeModal();
        this.search();
      }
    },
    async viewform(id) {
      this.$router.push(`/viewTemplate/visitlist/${id}`);
    },
    openModal(visitid) {
      this.selectedvisitid = visitid;
      const modalWrapper = document.querySelector('.modal-wrapper');
      modalWrapper.classList.add('active');
    },
    async addform() {
      this.$router.push(`/formdesigner/${this.templateId}`);
    },
    async createform() {
      this.$router.push(`/formdesigner/0`);
    },
    closeModal() {
      const modalWrapper = document.querySelector('.modal-wrapper');
      modalWrapper.classList.remove('active');
    },
    async setstudy() {
      this.studyid = store.getters.getStudyIs;
      await store.dispatch("setVisitStudyID", this.studyid);
    },
    async addvisit(id) {
      this.$router.push(`/addvisit/${id}`);
    },
    async search() {
      this.requestData.visitNo = this.searchData.visitNo;
      this.requestData.FormName = this.searchData.FormName;
      console.log(this.requestData);
      await this.searchAndGetData();
    },
    async settemplate(templateid, pageno, isFormFilled, formisds) {
      if (isFormFilled == true) {
        this.isedittrue = true;
        this.currentformid = formisds;
        this.getSignStatus();
      }
      else {
        this.isedittrue = false;
      }
      this.templateId = templateid;
      this.selectedpageno = pageno;
      store.dispatch("setselectedpageno", pageno);
    },
    async expandfun(visits,index,buttonClicked,initialCall) {

      if(this.currentIndex===this.concentdata.length-1 && !buttonClicked && initialCall===false) 
      {
        this.consentformvisible=true 
        this.disableInput=false
        this.currentIndex=0
        this.currentselectedformname = "e-Signature";
      }
      else{
        this.isFormLoading = true; 
      this.currentIndex=index
      this.esignvisitId = visits.visitId;
      this.esignsiteId = visits.siteId;
      this.esignsubjectId = visits.subjectId;
      this.esignstudyId = visits.studyId;
      this.consentformvisible = false;
      this.isIcfExpanded = false;
      this.clearIcfDocument();
      this.templateId = visits.tempId;
      this.currentselectedformname = visits.formName || visits.templateName || "Consent Forms";

      this.visitselected = true;
      if (visits.isFormFilled == true) {
        this.isedittrue = true;
        this.currentformid = visits.formId;
      }
      else {
        this.isedittrue = false;
      }
      await store.dispatch("setvisitId", visits.visitId);
      await store.dispatch("setvisitName", visits.visitFormName);
      this.visitidvar = visits.visitId;
      await this.gettemplates(visits, index);
      this.sheduleId = visits.sheduleId;
      if (this.expandfunvat.hasOwnProperty(visits.visitId)) {
        this.expandfunvat[visits.visitId] = !this.expandfunvat[visits.visitId];
      }
      else {
        this.expandfunvat[visits.visitId] = true;
      }
      }
      this.isFormLoading = false;
      this.updateconsentbysubject("SUBJECT_VIEWED");
      this.updateconsnetformviewed();
      this.getdata()
      
      // getSignStatus
    },
    async updateconsnetformviewed() {
      const idtoken = store.getters.getIdToken;
      await axios.put(
        `${this.baseapi}/management/patientlogin/updateformviewstatus?patientLoginId=${this.patientLoginId}`,
        {}, 
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          console.log("updated consent form viewed details", res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
     async updateconsentbysubject(status="SUBJECT_VIEWED") {
      const idtoken = store.getters.getIdToken;
      const consentId = this.currentformid || this.consentFormId || this.templateId || "";
      const studyID = this.esignstudyId || this.studyid || store.getters.getStudyIs || "";
      const subjectID = this.esignsubjectId || this.patientLogin.subjectID || "";

      if (!consentId || !studyID || !subjectID) {
        console.warn("Skipping updateconsentbysubject: missing required identifiers", {
          consentId,
          studyID,
          subjectID,
        });
        return;
      }

      const payload = {
        consentId,
        studyID,
        subjectID,
        status: status,
        ipAddress: "",
        device:"",
        browser: "",
        os: "",
        location: "",
        signatureType: "",
        signatureReason: "",
        comments: "",
        role: "",
        consentFormViewStatus: true,
        consentFormViewedDate: new Date().toISOString(),
      };

      await axios.put(
        `${this.baseapi}/management/patientdocument/updateconsentbysubject`,
        payload,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          console.log("updated consent form viewed details", res);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async gettemplates(visits, index) {
      const id = visits.visitId;
      const formfilledstatus = visits.isFormFilled;
      const formids = visits.formId;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/management/visit/getbyid/${visits.visitId}`,

          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {

          if (JSON.stringify(res.data) != '{}') {
            this.shoeaddeditbtn = true;
          }
          else {
            this.shoeaddeditbtn = false;
          }
          this.templatelist[index] = res.data;
          if (this.templatelist[index].template_ID == null) {
            this.templateId = "";
            this.addformvar = false;
            this.mountedValue = false
          }
          else {
            this.mountedValue = true
            this.addformvar = true;

          }
          console.log("visit list and index is ", this.templatelist, index)
          this.settemplate(this.templatelist[0].forms[index].template_ID, 1, formfilledstatus, formids);
          this.getPages(this.templatelist[0].forms[index].template_ID);

        })
        .catch((err) => {
          console.log(err);
        });

    },
    async getPages(id) {
      const idtoken = store.getters.getIdToken;
      // if(this.selectedpageid != id){
      // this.selectedpageid = id;
      await axios
        .get(
          `${this.baseapi}/forms/templatedesign/getpagesbyid?formId=${id}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            }
          }
        )
        .then((res) => {
          this.pages[id] = res.data.pages;
          // console.log("page")

        })
        .catch((err) => {
          if (err && id != null) {
            alert("No pages found")
          }
          console.error(err)

        });
      // }
    },
    async deleted(visitId) {
      this.visitides.push(visitId);
      const idtoken = store.getters.getIdToken;
      if (confirm("Do you really want to delete this visit?")) {
        await axios
          .delete(
            `${this.baseapi}/management/visit/delete?id=${visitId}`,
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            console.log(res);
            this.userList = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
      this.visitides = [];
      this.searchAndGetData();
    },
    async onPageClick(event) {
      this.requestData.pageindex = event;
      this.searchAndGetData();
    },
async getdata() {
  const idtoken = store.getters.getIdToken;
  
  if (!this.templateId) {
    console.log("No template ID available");
    this.templateData = null;
    return null;
  }
  
  try {
    this.isFormLoading = true;
    const res = await axios.get(
      `${this.baseapi}/forms/template/get/?templateId=${this.templateId}&api-version=1.0`,
      {
        headers: {
          Authorization: `Bearer ${idtoken}`,
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Template data loaded:", res.data);
    this.templateData = res.data;
    return res.data;
  } catch (error) {
    console.error("Error fetching template data:", error);
    this.templateData = null;
    // Show user-friendly error
    if (error.response?.status === 404) {
      console.log("Template not found for ID:", this.templateId);
    }
    return null;
  } finally {
    this.isFormLoading = false;
  }
},
async getDocumentdetails(documentId, version = 0) {
  const idtoken = store.getters.getIdToken;
  if (!documentId) {
    console.warn("No documentId provided");
    return null;
  }

  try {
    const url = `${this.baseapi}/etmf/document/getdocumentdetails?documentId=${documentId}&version=${version}`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${idtoken}`,
        "Content-Type": "application/json",
      },
    });

    console.log("Document details loaded:", response.data);
    return response.data; // contains document and docusign arrays
  } catch (error) {
    console.error("Error fetching document details:", error);
    return null;
  }
},

async getDocuments() {
  const idtoken = store.getters.getIdToken;
  this.isDocumentLoading = true;

      if (!this.patientLogin.subjectID) {
        await this.getPatientloginInfo();
      }

      const subjectId = this.patientLogin.subjectID || this.esignsubjectId || "";
      if (!subjectId) {
        this.documentlist = [];
        this.isDocumentLoading = false;
        return;
      }

      try {
        const response = await axios.get(
          `${this.baseapi}/management/patientdocument/listconsentformbystudy?StudyId=${store.getters.getStudyIs}&subjectId=${subjectId}&PageIndex=${this.pageindex}&PageSize=${this.pagesize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        this.documentlist = response.data.results || response.data.data || response.data || [];
        this.addScrollClass = this.documentlist.length >= 4;

        console.log("Documents loaded:", this.documentlist);
      } catch (error) {
        console.error("Error fetching documents:", error);
        this.documentlist = [];
        this.addScrollClass = false;
      } finally {
        this.isDocumentLoading = false;
      }
    },
    // async viewDocument(formId, versionNumber, document = null) {
    //   if (!formId) {
    //     return;
    //   }
    //   this.isIcfDocumentLoading = true;
    //   this.icfDocumentError = "";
    //   if (this.selectedIcfDocumentObjectUrl) {
    //     URL.revokeObjectURL(this.selectedIcfDocumentObjectUrl);
    //   }
    //   this.selectedIcfDocumentSource = "";
    //   this.selectedIcfDocumentObjectUrl = "";
    //   this.selectedIcfDocument = document;
    //   this.consentformvisible = true;

    //   const version = versionNumber || 0;
    //   const primarySource = `${this.baseapi}/etmf/document/documentfile/${formId}?version=${version}`;
    //   const fallbackSource = `${process.env.VUE_APP_File_upload_URL}/document/file/${formId}?versionid=${version}`;

    //   try {
    //     console.log("Attempting to load document from primary source:", primarySource);
    //     this.selectedIcfDocumentObjectUrl =
    //       (await this.fetchDocumentSource(primarySource)) ||
    //       (await this.fetchDocumentSource(fallbackSource));

    //     console.log("Selected document object URL:", this.selectedIcfDocumentObjectUrl);

    //     if (!this.selectedIcfDocumentObjectUrl) {
    //       this.icfDocumentError = "Unable to load ICF document";
    //       return;
    //     }

    //     this.selectedIcfDocumentSource = this.selectedIcfDocumentObjectUrl;
    //     this.currentselectedformname =
    //       document?.formName ||
    //       document?.documentTitle ||
    //       document?.documentName ||
    //       "ICF Form";
    //   } catch (error) {
    //     console.error("Error loading ICF document:", error);
    //     this.icfDocumentError = "Unable to load ICF document";
    //   } finally {
    //     this.isIcfDocumentLoading = false;
    //   }
    // },
    async viewDocument(formId, versionNumber, document) {
  try {
    this.isIcfDocumentLoading = true;
    this.icfDocumentError = "";

    const idtoken = store.getters.getIdToken;
    const version = versionNumber || 0;
    const docDetails = await this.getDocumentdetails(formId, version);
    
    let storageId = null;
    let versionId = null;
    
    if (docDetails && docDetails.document && docDetails.document.documentVersions && docDetails.document.documentVersions.length > 0) {
      const targetVersion = docDetails.document.documentVersions.find(v => v.version == version) || docDetails.document.documentVersions[0];
      storageId = targetVersion.storageId;
      versionId = targetVersion.versionId;
    }
    const primarySource = `${this.baseapi}/etmf/document/documentfile/${formId}?version=${version}`;
    console.log("Primary document source URL:", primarySource);
    let fallbackSource = null;
    if (storageId && versionId) {
      fallbackSource = `${process.env.VUE_APP_File_upload_URL}/document/file/${storageId}?versionId=${versionId}`;
    } else {
      fallbackSource = `${process.env.VUE_APP_File_upload_URL}/document/file/${formId}?versionid=${version}`;
    }

    let source = await this.fetchDocumentSource(primarySource);
    console.log("Document source from primary URL:", source);
    if (!source && fallbackSource) {
      source = await this.fetchDocumentSource(fallbackSource);
    }

    if (source) {
      this.selectedIcfDocument = document;
      this.selectedIcfDocumentSource = source;
      this.selectedIcfDocumentObjectUrl = source;
      this.currentselectedformname =
        document?.formName ||
        document?.documentTitle ||
        document?.documentName ||
        "ICF Form";
    } else {
      this.icfDocumentError = "Unable to load document";
    }
  } catch (err) {
    console.error("Error in viewDocument:", err);
    this.icfDocumentError = "Failed to fetch document";
  } finally {
    this.isIcfDocumentLoading = false;
  }
},
// async viewDocument(formId, versionNumber, document) {
//   try {
//     this.isIcfDocumentLoading = true;
//     this.icfDocumentError = "";

//     const idtoken = store.getters.getIdToken;
//     const version = versionNumber || 0;

//     const primarySource = `${this.baseapi}/etmf/document/documentfile/${formId}?version=${version}`;
//     await this.getDocumentdetails();
//     const fallbackSource = `${process.env.VUE_APP_File_upload_URL}/document/file/${formId}?versionid=${version}`;

//     let source = await this.fetchDocumentSource(primarySource);
//     if (!source) {
//       source = await this.fetchDocumentSource(fallbackSource);
//     }

//     if (source) {
//       this.selectedIcfDocument = document;
//       this.selectedIcfDocumentSource = source;
//       this.selectedIcfDocumentObjectUrl = source;
//     } else {
//       this.icfDocumentError = "Unable to load document";
//     }
//   } catch (err) {
//     console.error("Error in viewDocument:", err);
//     this.icfDocumentError = "Failed to fetch document";
//   } finally {
//     this.isIcfDocumentLoading = false;
//   }
// }


// async getdata() {
//   const idtoken = store.getters.getIdToken;
  
//   // Check if templateId exists before making the API call
//   if (!this.templateId) {
//     console.log("No template ID available");
//     return;
//   }
  
//   try {
//     const res = await axios.get(
//       `${this.baseapi}/forms/template/get/?templateId=${this.templateId}&api-version=1.0`,
//       {
//         headers: {
//           Authorization: `Bearer ${idtoken}`,
//           "Content-Type": "application/json",
//         },
//       }
//     );
//     console.log("res", res.data);
//     return res.data;
//   } catch (error) {
//     console.error("Error fetching template data:", error);
//   }
// }
  }
}

